import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from '../components/FadeIn';
import { SafeImage } from '../components/SafeImage';
import { WhatsAppButton } from '../components/WhatsAppButton';
const BENEFITS = ['Cold plunges', 'Wood-fired sauna', 'Cedar hot tub', 'Pool (seasonal)', 'Member pricing', 'Guest passes'];
const OPTIONS = [{
  title: 'Casual visit',
  status: 'Available',
  note: 'Come for a single session of sauna, hot tub and cold water.'
}, {
  title: '10 visit pass',
  status: 'Available',
  note: 'Ten visits to use at your own pace, at member pricing.'
}, {
  title: 'Monthly membership',
  status: 'Coming soon',
  note: 'Unlimited weekly access. Join the list and Zev will let you know first.'
}];
export function MembershipPage() {
  return <>
      <section className="bg-cream px-6 py-20 md:px-12 md:py-32" data-id="element-712" data-mp="35evlqp926cmp">
        <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-713" data-mp="3ablzv71ayy5h">
          <div data-id="element-714" data-mp="j96cwb5dp6wu">
            <FadeIn data-id="element-715" data-mp="j9plv2d1wkyq">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-716" data-mp="ja95cnicnhev">
                Pines Membership
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-717" data-mp="agmbj2xpco8b">
              <h1 className="mb-7 font-serif text-5xl leading-[1.05] text-pine md:text-6xl" data-id="element-718" data-mp="adqah5qk5jfn">
                Your weekly reset.
              </h1>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-719" data-mp="125piwrkvyep6">
              <p className="mb-10 max-w-xl text-lg font-light leading-relaxed text-clay md:text-xl" data-id="element-720" data-mp="124o54fchje3r">
                Regular access to the space for your own wellbeing — make Pines Retreat
                part of your routine rather than a once-a-year escape.
              </p>
            </FadeIn>
            <FadeIn delay={0.3} data-id="element-721" data-mp="o9lq92pnueet">
              <p className="mb-5 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-722" data-mp="3dx2vu6f9vga4">
                Benefits
              </p>
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-723" data-mp="38vvo27d4qh3g">
                {BENEFITS.map(benefit => <div key={benefit} className="flex items-center gap-3 text-pine/90" data-id="element-724" data-mp="3acj6upq81ze7">
                    <CheckCircle2 className="h-4 w-4 flex-none text-ember" data-id="element-725" data-mp="3fcxggc7h1hec" />
                    <span className="font-light" data-id="element-726" data-mp="31d5vtsmg92rd">{benefit}</span>
                  </div>)}
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.2} data-id="element-727" data-mp="2roe9q142lcod">
            <div className="relative overflow-hidden rounded-sm" data-id="element-728" data-mp="2rn34dwuz7wv5">
              <SafeImage src="https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg" alt="Pines Retreat sauna at night" className="aspect-[4/5] h-full w-full object-cover" data-id="element-729" data-mp="2wekvlt776j2x" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/60 to-transparent" data-id="element-730" data-mp="2dntq52qbzctt" />
              <div className="absolute bottom-0 left-0 p-7 text-cream" data-id="element-731" data-mp="1u338qjae36dj">
                <p className="font-serif text-2xl" data-id="element-732" data-mp="1p49wsvar3nfh">Heat, cold, quiet. Every week.</p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <section className="bg-creamDeep px-6 py-20 md:px-12 md:py-28" data-id="element-733" data-mp="1z1o0dubkshqd">
        <div className="mx-auto max-w-6xl" data-id="element-734" data-mp="1z0cvfr6e93xo">
          <FadeIn data-id="element-735" data-mp="2d0xdgl4hivq4">
            <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-736" data-mp="2d0dx38uhgfe7">
              Options
            </p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-737" data-mp="280i1nxzupwa9">
            <h2 className="mb-10 max-w-2xl font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-738" data-mp="2mrs0hrpk1zcm">
              Choose the rhythm that works for you.
            </h2>
          </FadeIn>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-739" data-mp="2vrnfy8q58gig">
            {OPTIONS.map((option, index) => <FadeIn key={option.title} delay={index * 0.08} data-id="element-740" data-mp="2rr4o4eo93ag9" data-mpi={index}>
                <div className="flex h-full min-h-52 flex-col rounded-sm border border-pine/15 bg-cream p-6" data-id="element-741" data-mp="2roigyg59uwyk">
                  <span className={`text-xs font-medium uppercase tracking-[0.18em] ${option.status === 'Coming soon' ? 'text-clay/60' : 'text-ember'}`} data-id="element-742" data-mp="u2rar5srhlnw">
                    {option.status}
                  </span>
                  <h3 className="mb-3 mt-auto font-serif text-2xl text-pine" data-id="element-743" data-mp="64shcqnltva0">
                    {option.title}
                  </h3>
                  <p className="font-light leading-relaxed text-clay" data-id="element-744" data-mp="b4y8m5pypfrk">{option.note}</p>
                </div>
              </FadeIn>)}
          </div>
          <FadeIn delay={0.3} className="mt-10" data-id="element-745" data-mp="k4lep4tmz9qy">
            <WhatsAppButton label="Join Pines Membership" data-id="element-746" data-mp="k5cx1dy83aza" />
          </FadeIn>
        </div>
      </section>
    </>;
}